/**
 * - ref: https://developers.cloudflare.com/turnstile/troubleshooting/client-side-errors/error-codes/
 */
const RETRIABLE_ERROR_CODES = {
  INVALID_PARAMETERS: {
    codes: ['102***', '103***', '104***', '106***'],
    retry: true,
  },
  CHALLENGE_TIMED_OUT: {
    codes: ['11060*', '11062*'],
    retry: true,
  },
  GENERIC_CLIENT_EXECUTION_ERROR: {
    codes: ['300***'],
    retry: true,
  },
  CHALLENGE_EXECUTION_FAILURE: {
    codes: ['600***'],
    retry: true,
  },
}

const NON_RETRIABLE_ERROR_CODES = {
  INITIALIZATION_ERROR: {
    codes: ['100***'],
    retry: false,
  },
  TURNSTILE_API_COMPATIBILITY: {
    codes: ['105***'],
    retry: false,
  },
  INVALID_SITEKEY: {
    codes: ['110100', '110110'],
    retry: false,
  },
  UNKNOWN_DOMAIN: {
    codes: ['110200'],
    retry: false,
  },
  INVALID_ACTION: {
    codes: ['110420'],
    retry: false,
  },
  INVALID_CDATA: {
    codes: ['110430'],
    retry: false,
  },
  UNSUPPORTED_BROWSER: {
    codes: ['110500'],
    retry: false,
  },
  INCONSISTENT_USER_AGENT: {
    codes: ['110510'],
    retry: false,
  },
  INVALID_CACHING: {
    codes: ['200010'],
    retry: false,
  },
  TIME_PROBLEM: {
    codes: ['200100'],
    retry: false,
  },
}

export const TURNSTILE_ERROR_CODES = {
  ...RETRIABLE_ERROR_CODES,
  ...NON_RETRIABLE_ERROR_CODES,
}
